import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import type { RootState } from "../store";
import { getEventsEvolutionRequest } from "../store/eventsEvolutionDuck";

export const useEventsEvolution = () => {
  const dispatch = useDispatch();
  const event = useSelector((state: RootState) => state.eventsEvolution.event);
  const status = useSelector(
    (state: RootState) => state.eventsEvolution.requests.getEvent.status,
  );
  const error = useSelector(
    (state: RootState) => state.eventsEvolution.requests.getEvent.error,
  );

  const loadEvent = useCallback(
    (id: string) => {
      dispatch(getEventsEvolutionRequest({ id }));
    },
    [dispatch],
  );

  return {
    event,
    status,
    error,
    loadEvent,
  };
};
